module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discountManaEdit"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "auto",
      "model": _vm.secondInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "优惠名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.secondInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "name", $$v)
      },
      expression: "secondInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "优惠方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.secondInfo.type),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "type", $$v)
      },
      expression: "secondInfo.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'discount'
    }
  }, [_vm._v("打折")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'reduce'
    }
  }, [_vm._v("减免金额")])], 1)], 1), _vm._v(" "), (_vm.secondInfo.type == 'discount') ? _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "折扣"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.secondInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "discount", $$v)
      },
      expression: "secondInfo.discount"
    }
  }), _vm._v("折\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.secondInfo.type == 'reduce') ? _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "减免金额"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.secondInfo.reduceAmount),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "reduceAmount", $$v)
      },
      expression: "secondInfo.reduceAmount"
    }
  }), _vm._v("元\n      ")], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生效时间"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.secondInfo.timeEnableType),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "timeEnableType", $$v)
      },
      expression: "secondInfo.timeEnableType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'custom'
    }
  }, [_vm._v("自定义时间")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'forever'
    }
  }, [_vm._v("永久有效")])], 1)], 1), _vm._v(" "), (_vm.secondInfo.timeEnableType == 'custom') ? _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "请选择时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOptions,
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.secondInfo.timeForAuto),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "timeForAuto", $$v)
      },
      expression: "secondInfo.timeForAuto"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "请选择时间范围"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "is-range": "",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "placeholder": "选择时间范围"
    },
    model: {
      value: (_vm.secondInfo.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "timeRange", $$v)
      },
      expression: "secondInfo.timeRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "星期选择"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleChangeWeeksAll
    },
    model: {
      value: (_vm.isAllWeek),
      callback: function($$v) {
        _vm.isAllWeek = $$v
      },
      expression: "isAllWeek"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleChangeWeeks
    },
    model: {
      value: (_vm.secondInfo.week),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "week", $$v)
      },
      expression: "secondInfo.week"
    }
  }, _vm._l((_vm.weeks), function(weekItem) {
    return _c('el-checkbox', {
      key: weekItem,
      attrs: {
        "label": weekItem
      }
    }, [_vm._v(_vm._s(weekItem))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "10px",
      "color": "red",
      "width": "50%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticClass: "select-wrap",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-cont"
  }, [_c('div', {
    staticClass: "goods-left"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("商品选择")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "row-key": _vm.getRowKeys
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "select": _vm.toggleSelection,
      "select-all": _vm.toggleSelectionAll
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55",
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesPrice",
      "label": "价格",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提成"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.discountCommission),
            expression: "scope.row.discountCommission"
          }],
          staticStyle: {
            "width": "60px"
          },
          attrs: {
            "type": "text",
            "placeholder": "提成金额"
          },
          domProps: {
            "value": (scope.row.discountCommission)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(scope.row, "discountCommission", $event.target.value)
            }
          }
        }), _vm._v("元\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "分类"
    }
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back"
  }, [_c('span', {
    staticClass: "right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b7b6698e","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/activity/second/modifySecond/index.vue
// module id = 978
// module chunks = 1